import {
  educationLevel,
  FOR_ME_IS_TRUE,
  INITIAL_SUBMIT,
  NAUTICALPDBLUE,
} from "../../../constants";
import dayjs from "dayjs";

const generateInitialValues = (
  id,
  applicationKinds,
  portAuthorities,
  user,
  forMe,
  translatedGender,
  nauticalPdColor,
  t,
  gatewayData
) => {
  const translatedEducationLevel = educationLevel?.map((option) => ({
    ...option,
    dscr: t(`${option.dscr}`),
  }));

  let epipedoEkpaideusisInitialValue =
    nauticalPdColor === NAUTICALPDBLUE
      ? translatedEducationLevel[1]
      : translatedEducationLevel[0];

  const genderInitialValue = translatedGender.find(
    (item) => item.dscr === gatewayData?.registryServiceData?.gender
  );

  return {
    disabledConfiguration: gatewayData?.disabledConfiguration,
    appl_kind_id: id,
    applicationKind:
      applicationKinds?.find((applKind) => applKind.id == id)?.dscr || "",
    portAuthority: portAuthorities?.find(
      (portAuth) => portAuth.id === user?.port_auth_id
    ),
    pickup_place: portAuthorities?.find(
      (portAuth) => portAuth.id === user?.port_auth_id
    ),
    appl_dt: dayjs().format("DD/MM/YYYY"),
    reg_num: null,

    // Επώνυμο (Αιτούντα) (Κλειδωμένο πεδίο) [ΜΠ]
    lname_ait:
      forMe !== FOR_ME_IS_TRUE ? gatewayData?.registryServiceData.lname : "",
    // Όνομα (Αιτούντα) (Κλειδωμένο πεδίο) [ΜΠ]
    fname_ait:
      forMe !== FOR_ME_IS_TRUE ? gatewayData?.registryServiceData.fname : "",
    // ΑΦΜ  (Αιτούντα)(Κλειδωμένο πεδίο)
    afm_ait: user?.afm,
    //ΑΜΚΑ (Αιτούντα)   (Να μπορεί να γίνει edit) [ΜΠ] ή [ΕΦΚΑ] ?
    amka_ait: forMe !== FOR_ME_IS_TRUE ? gatewayData?.efkaData.amka : "",
    //
    meth_ait: "",
    // ΑΔΤ (Αιτούντα)(Αστυνομική Ταυτότητα)  (Να μπορεί να γίνει edit)![ΜΠ]
    ind_nr_ait:
      forMe !== FOR_ME_IS_TRUE ? gatewayData?.registryServiceData.ind_nr : "",
    // Επώνυμο Πατέρα (Αιτούντα (Κλειδωμένο πεδίο)[ΜΠ]
    fath_lname_ait:
      forMe !== FOR_ME_IS_TRUE
        ? gatewayData?.registryServiceData.fath_lname
        : "",
    // Όνομα Πατέρα  (Αιτούντα)(Κλειδωμένο πεδίο)[ΜΠ]
    fath_fname_ait:
      forMe !== FOR_ME_IS_TRUE
        ? gatewayData?.registryServiceData.fath_fname
        : "",
    // Διεύθυνση  (Αιτούντα) (Να μπορεί να γίνει edit)[ΜΠ]
    address_ait:
      forMe !== FOR_ME_IS_TRUE ? gatewayData?.registryServiceData.address : "",
    // Αριθμός Διεύθυνσης   (Αιτούντα)(Να μπορεί να γίνει edit)[ΜΠ]
    address_nr_ait:
      forMe !== FOR_ME_IS_TRUE
        ? gatewayData?.registryServiceData.address_nr
        : "",
    // ΤΚ   (Αιτούντα)(Να μπορεί να γίνει edit)[ΜΠ]
    tk_ait: forMe !== FOR_ME_IS_TRUE ? gatewayData?.registryServiceData.tk : "",
    // Αριθμός τηλεφώνου(Αιτούντα) (Να μπορεί να γίνει edit)[ΜΕΠ]
    tel_ait:
      forMe !== FOR_ME_IS_TRUE
        ? gatewayData?.notificationCenterElementsServiceData.tel
        : "",
    // Αριθμός Κινητού τηλεφώνου(Αιτούντα) (Να μπορεί να γίνει edit)[ΜΕΠ]
    mobile_ait:
      forMe !== FOR_ME_IS_TRUE
        ? gatewayData?.notificationCenterElementsServiceData.mobile
        : "",
    // Email (Αιτούντα) (Να μπορεί να γίνει edit)[ΜΕΠ]
    email_ait:
      forMe !== FOR_ME_IS_TRUE
        ? gatewayData?.notificationCenterElementsServiceData.email
        : "",

    // Επώνυμο (Αίτηση αφορά τον ίδιο) (Κλειδωμένο πεδίο) [ΜΠ]
    lname_afora:
      forMe === FOR_ME_IS_TRUE ? gatewayData?.registryServiceData.lname : "",
    // Όνομα (Αίτηση αφορά τον ίδιο) (Κλειδωμένο πεδίο)[ΜΠ]
    fname_afora:
      forMe === FOR_ME_IS_TRUE ? gatewayData?.registryServiceData.fname : "",
    // ΑΦΜ  (Αίτηση αφορά τον ίδιο)(Κλειδωμένο πεδίο)[ΜΠ]
    afm_afora: forMe === FOR_ME_IS_TRUE ? user?.afm : "",
    // ΑΜΚΑ (Αίτηση αφορά τον ίδιο)   (Κλειδωμένο πεδίο) ! [ΜΠ] ή [ΕΦΚΑ] ?
    amka_afora: forMe === FOR_ME_IS_TRUE ? gatewayData?.efkaData.amka : "",
    // Δεν ειναι απο διαλειτουργικοτητα
    meth_afora: "",
    // Αριθμός Διεύθυνσης   (Αίτηση αφορά τον ίδιο)(Να μπορεί να γίνει edit)[ΜΠ]
    ind_nr_afora:
      forMe === FOR_ME_IS_TRUE ? gatewayData?.registryServiceData.ind_nr : "",
    // Επώνυμο Πατέρα (Αίτηση αφορά τον ίδιο) (Κλειδωμένο πεδίο) ![ΜΠ]
    fath_lname_afora:
      forMe === FOR_ME_IS_TRUE
        ? gatewayData?.registryServiceData.fath_lname || "-"
        : "",
    // Όνομα Πατέρα  (Αίτηση αφορά τον ίδιο) (Κλειδωμένο πεδίο) ![ΜΠ]
    fath_fname_afora:
      forMe === FOR_ME_IS_TRUE
        ? gatewayData?.registryServiceData.fath_fname || "-"
        : "",
    // Επώνυμο Μητρός  (Αίτηση αφορά τον ίδιο)(Κλειδωμένο πεδίο) ![ΜΠ]
    moth_lname_afora:
      forMe === FOR_ME_IS_TRUE
        ? gatewayData?.registryServiceData.moth_lname || "-"
        : "",
    // Όνομα Μητρός (Αίτηση αφορά τον ίδιο)(Κλειδωμένο πεδίο) ![ΜΠ]
    moth_fname_afora:
      forMe === FOR_ME_IS_TRUE
        ? gatewayData?.registryServiceData.moth_fname || "-"
        : "",
    // Ημερομηνία Γέννησης (Αίτηση αφορά τον ίδιο)  (Κλειδωμένο πεδίο) ![ΜΠ]
    dt_birth_afora:
      forMe === FOR_ME_IS_TRUE
        ? new Date(gatewayData?.registryServiceData?.dt_birth)
        : null,
    // Τόπος Γέννησης  (Αίτηση αφορά τον ίδιο)(? Εξωτερικό) Θα πρέπει θεωρητικά
    // να προσυμπληρώνεται και αν δεν υπάρχει να μπαίνει εξωτερικό όπως έχει
    // ζητηθεί και να συμπληρώνουν τον τόπο που έχουν γεννηθεί εξωτερικό - [ΜΠ]
    place_birth_afora:
      forMe === FOR_ME_IS_TRUE
        ? gatewayData?.registryServiceData.place_birth_id
        : null,
    // Δήμος Διαμονής   (Αίτηση αφορά τον ίδιο)(Να μπορεί να γίνει edit)
    // [ΜΠ] ή να το συμπληρώνει ο ίδιος?
    dimos_diamonis_afora:
      forMe === FOR_ME_IS_TRUE
        ? gatewayData?.registryServiceData.dimos_diamonis
        : null,
    //
    topos_eggrafis_dimotologiou_ellada: forMe === FOR_ME_IS_TRUE ? "" : "",
    // Διεύθυνση  (Αίτηση αφορά τον ίδιο) (Να μπορεί να γίνει edit)[ΜΠ]
    address_afora:
      forMe === FOR_ME_IS_TRUE ? gatewayData?.registryServiceData.address : "",
    // Αριθμός Διεύθυνσης   (Αίτηση αφορά τον ίδιο)(Να μπορεί να γίνει edit)[ΜΠ]
    address_nr_afora:
      forMe === FOR_ME_IS_TRUE
        ? gatewayData?.registryServiceData.address_nr
        : "",
    // ΤΚ   (Αίτηση αφορά τον ίδιο)(Να μπορεί να γίνει edit)[ΜΠ]
    tk_afora:
      forMe === FOR_ME_IS_TRUE ? gatewayData?.registryServiceData.tk : "",
    // Αριθμός τηλεφώνου (Αίτηση αφορά τον ίδιο) (Να μπορεί να γίνει edit) [ΜΕΠ]
    tel_afora:
      forMe === FOR_ME_IS_TRUE
        ? gatewayData?.notificationCenterElementsServiceData.tel
        : "",
    // Αριθμός Κινητού τηλεφώνου (Αίτηση αφορά τον ίδιο) (Να μπορεί να γίνει edit) [ΜΕΠ]
    mobile_afora:
      forMe === FOR_ME_IS_TRUE
        ? gatewayData?.notificationCenterElementsServiceData.mobile
        : "",
    // Email (Το δίνει το μητρώο πολιτών σε άλλη μέθοδο  (Αίτηση αφορά τον ίδιο) (Να μπορεί να γίνει edit)[ΜΕΠ]
    email_afora:
      forMe === FOR_ME_IS_TRUE
        ? gatewayData?.notificationCenterElementsServiceData.email
        : "",

    status: INITIAL_SUBMIT,
    documents: [],
    sintaksiouxos_afora: "",
    epipedo_ekpaideusis_afora: epipedoEkpaideusisInitialValue,
    gender_afora: forMe === FOR_ME_IS_TRUE ? genderInitialValue : null,
    nationality_afora:
      forMe === FOR_ME_IS_TRUE
        ? gatewayData?.registryServiceData.nationality
        : "",
    read_dilosi_idiotiton: "",
    reason_for_copy_nautical_issue: "",
    didacticYear: null,
    birth_country:
      forMe === FOR_ME_IS_TRUE
        ? gatewayData?.registryServiceData?.birth_country
        : null,
    birth_city_not_greece: "",
    criminal_record_requestId: "",
  };
};

export default generateInitialValues;
